import { css } from "@emotion/css"
import { useContext } from "react"

import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../constant/fieldNames"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../types"
import OneClickEstimateContext from "../../../OneClickEstimateContext"
import OneClickField from "../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../components/1Click/form/Radio/Radio"
import isValidMetalMaskDtl from "../../../service/visibleValidator/isValidMetalMaskDtl"

const メタルマスクの製造支給選択 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { metalMaskDtl: shouldShow } = getDisplayCondition(values)
  const { metalMaskStockPartName } = useContext(OneClickEstimateContext)
  // GugenHubでメタルマスク在庫を選択している場合、全選択肢を非活性にする。
  // 裏ではPBAN("4")がバックエンドに送信される（useRestoreValues.tsで設定）。
  const hasGhMetalMask = !!metalMaskStockPartName

  const noGarberValue =
    ESTIMATE_CONSTANT["メタルマスクの製造・支給選択"][
      "マスク用ガーバーデータが無く、基板ガーバーデータ一式から製造する"
    ].value

  return (
    <OneClickField isShow={shouldShow} disabled={hasGhMetalMask} legend="メタルマスクの製造・支給選択">
      <RadioGroup
        name={FIELD_NAMES["メタルマスクの製造・支給選択"]}
        selectedValue={values.metalMaskDtl}
        onChange={handlers.radio}
        disabled={hasGhMetalMask}
        shouldRender={(value) => isValidMetalMaskDtl(values, value)}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT["メタルマスクの製造・支給選択"].マスク用ガーバーデータから製造する.value}>
            マスク用ガーバーデータから製造する
          </Radio>
          <Radio value={noGarberValue}>
            <div className={style}>
              マスク用ガーバーデータが無く、基板ガーバーデータ
              {/* 改行されないようにする */}
              <span>一式</span>
              から製造する
            </div>
          </Radio>
          <Radio value={ESTIMATE_CONSTANT["メタルマスクの製造・支給選択"].お客様より支給あり.value}>
            お客様より支給あり
          </Radio>
        </OneClickFieldStack>
      </RadioGroup>
      {/* TODO サーバーからのエラーレスポンスはmetalmaskに入ってる */}
      <OneClickFieldMessages error={errors?.metalmask} />
    </OneClickField>
  )
}

export default メタルマスクの製造支給選択

const style = css`
  text-align: left;
  > span {
    display: inline-block;
  }
`
